var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mtb-80"},[_c('div',{staticClass:"title f32 text-center",domProps:{"textContent":_vm._s(_vm.tag.name)}})]),_vm._v(" "),_c('proyectos-area',{staticClass:"mb-8",attrs:{"proyectos":_vm.tag.posts,"vermas":false}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af033cb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/tags_posts.vue
// module id = q+RP
// module chunks = 0